export default __webpack_public_path__ + "static/media/loader-dark.5bf54a1c.gif";